// Returns the medium value of an array of numbers.
export function median(arr){
  arr.sort((a, b) => a - b);
  var i = arr.length / 2;
  return i % 1 === 0 ? (arr[i - 1] + arr[i]) / 2 : arr[Math.floor(i)];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-regression@1.3.5@d3-regression/src/utils/median.js
// module id = null
// module chunks = 